<script lang="ts">
import { defineComponent as DO_defineComponent } from 'vue';
export default /*#__PURE__*/ DO_defineComponent({
    name: 'IButton',
  });
</script>
<script lang="ts" setup>
  import lodash from 'lodash';

  defineProps({
  "type": { type: String, required: false, default: 'primary' }
});
  console.log(lodash.chunk(['a', 'b', 'c', 'd'], 2));
  ;
</script>

<template>
  <button class="mu_Button" :class="type">
    <slot></slot>
  </button>
</template>

<style scoped></style>
